module.exports = __webpack_public_path__ + "static/media/my_adviser.d4d117f7.jpg";